var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrdersList',{attrs:{"orderData":_vm.orderData,"totalDocs":_vm.totalDocs,"page":_vm.page,"noDataText":_vm.noDataText},on:{"fetchList":_vm.getOrdersList,"viewOrderDetail":_vm.viewOrderDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }